<template>
  <v-app-bar
    height="80"
    v-scroll="onScroll"
    :color="'uniColor'"
    :hide-on-scroll="$vuetify.breakpoint.smAndDown"
    app
    dark
    fixed
    id="menuPrincipal"
    class="tech-app-bar"
    :class="{ 'scrolled-nav': isScrolling }"
  >
    <div class="neon-border-bottom"></div>

    <router-link to="/" class="d-flex align-center" style="text-decoration: none;">
      <v-img 
        alt="Nic" 
        class="shrink logo-glow mr-2" 
        max-width="120" 
        src="/static/logoNic.png" 
        transition="scale-transition"
      />
    </router-link>

    <v-spacer />

    <div v-if="$vuetify.breakpoint.mdAndUp" class="d-flex align-center">
      
      <v-btn
        v-for="(item, i) in items"
        :key="i"
        :to="item.to"
        text
        class="nav-btn mono-font mx-1 white--text"
        active-class="nav-active"
      >
        <v-icon left small color="cyan accent-3">mdi-home-outline</v-icon>
        {{ item.text }}
      </v-btn>

      <v-menu offset-y open-on-hover transition="slide-y-transition" bottom content-class="tech-menu-content">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            v-bind="attrs"
            v-on="on"
            class="nav-btn mono-font mx-1 white--text"
          >
            <v-icon left small color="cyan accent-3">mdi-account-group-outline</v-icon>
            Nosotros
            <v-icon right small>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list dense class="tech-list pa-0">
          <v-list-item
            v-for="(item, index) in items1"
            :key="index"
            :to="item.to"
            class="tech-list-item"
          >
            <v-list-item-icon class="mr-2"><v-icon x-small color="cyan">mdi-menu-right</v-icon></v-list-item-icon>
            <v-list-item-title class="mono-font white--text">{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn
        v-for="(item, i) in items5"
        :key="'U' + i"
        :to="item.to"
        text
        class="nav-btn mono-font mx-1 white--text"
        active-class="nav-active"
      >
        <v-icon left small color="green accent-3">mdi-radar</v-icon>
        {{ item.text }}
      </v-btn>

      <v-menu offset-y open-on-hover transition="slide-y-transition" bottom content-class="tech-menu-content">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            v-bind="attrs"
            v-on="on"
            class="nav-btn mono-font mx-1 white--text"
          >
            <v-icon left small color="cyan accent-3">mdi-domain</v-icon>
            Dominios
            <v-icon right small>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list dense class="tech-list pa-0">
          <v-list-item
            v-for="(item, index) in items2"
            :key="index"
            :to="item.to"
            class="tech-list-item"
          >
            <v-list-item-icon class="mr-2"><v-icon x-small color="cyan">mdi-menu-right</v-icon></v-list-item-icon>
            <v-list-item-title class="mono-font white--text">{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn
        v-for="(item, i) in items3"
        :key="'C' + i"
        :to="item.to"
        text
        class="nav-btn mono-font mx-1 white--text"
        active-class="nav-active"
      >
        <v-icon left small color="cyan accent-3">mdi-email-outline</v-icon>
        {{ item.text }}
      </v-btn>

      <div class="ml-4">
        <template v-if="isLogged">
          <v-tooltip bottom content-class="tech-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                @click="redirectToDashboard"
                class="dashboard-btn"
              >
                <v-icon color="cyan accent-3">mdi-view-dashboard</v-icon>
              </v-btn>
            </template>
            <span class="mono-font">ACCESO_ADMIN</span>
          </v-tooltip>
        </template>
      </div>

    </div>

    <v-app-bar-nav-icon
      v-else
      @click="toggleDrawer"
      class="glow-icon white--text"
    />

  </v-app-bar>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data: () => ({
    isScrolling: false 
  }),

  computed: {
    isLogged: {
      get() {
        return this.$store.getters.isLogged;
      },
    },
    items() { return [{ to: "/", text: "Inicio" }]; },
    items5() { return [{ to: "/whois", text: "WhoIs" }]; },
    items1() {
      return [
        { to: "/quienessomos", text: "Quiénes Somos" },
        { to: "/historia", text: "Historia" },
        { to: "/valores", text: "Valores" },
        { to: "/corresponsales", text: "Corresponsales" },
      ];
    },
    items2() {
      return [
        { to: "/buscardominio", text: "Buscar Dominio" },
        { to: "/informaciongeneral", text: "Información General" },
        { to: "/PasosDom", text: "Pasos Para Obtener Dominio" },
        { to: "/requisitos", text: "Requisitos Registro Dominio" },
        { to: "/registronuevodominio", text: "Registro Nuevo Dominio" },
        { to: "/renovaciondominio", text: "Renovación Dominio" },
      ];
    },
    items3() { return [{ to: "/contactenos", text: "Contáctenos" }]; },
  },

  methods: {
    ...mapMutations(["toggleDrawer"]),
    onScroll() {
      this.isScrolling = (window.pageYOffset || document.documentElement.scrollTop || 0) > 25;
    },
    redirectToDashboard() {
      window.location.href = "/panel";
    },
  },
};
</script>

<style scoped>
/* --- ESTILOS TECH NAV BAR --- */
@import url('https://fonts.googleapis.com/css2?family=Fira+Code:wght@400;600&display=swap');

/* Fuente Monoespaciada para Menú */
.mono-font {
  font-family: 'Fira Code', monospace !important;
  font-size: 1.2rem !important; /* Un poco más grande para mejor lectura en blanco */
  letter-spacing: 0.5px;
}

/* Barra Principal */
.tech-app-bar {
  /* backdrop-filter: blur(10px);  <-- Eliminado el blur si el color es sólido, o se puede dejar si uniColor tiene transparencia */
  border-bottom: 1px solid rgba(0, 229, 255, 0.2);
  transition: all 0.3s ease;
}

.scrolled-nav {
  /* Opcional: Si quieres que cambie ligeramente al hacer scroll, sino puedes quitar esta clase */
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.3);
}

/* Borde Neón Inferior */
.neon-border-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px; /* Un poco más grueso para destacar sobre el azul */
  background: linear-gradient(90deg, transparent, #00e5ff, transparent);
  box-shadow: 0 0 15px #00e5ff;
  opacity: 0.8;
}

/* Botones de Navegación */
.nav-btn {
  /* color: white definido en el template mediante white--text */
  transition: all 0.3s ease;
  border-radius: 4px;
  opacity: 0.9;
}

.nav-btn:hover {
  opacity: 1;
  background-color: rgba(0, 229, 255, 0.15) !important; /* Fondo cian sutil al pasar mouse */
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.8), 0 0 5px rgba(0, 229, 255, 0.8); /* Resplandor blanco/cian */
}

.nav-active {
  color: #ffffff !important;
  background-color: rgba(0, 229, 255, 0.1) !important;
  border-bottom: 3px solid #00e5ff; /* Borde inferior más visible */
  text-shadow: 0 0 8px rgba(0, 229, 255, 0.6);
}

/* Logo Resplandor */
.logo-glow {
  filter: drop-shadow(0 0 5px rgba(0, 229, 255, 0.3));
  transition: filter 0.3s;
}
.logo-glow:hover {
  filter: drop-shadow(0 0 10px rgba(0, 229, 255, 0.6));
}

/* Botón Dashboard */
.dashboard-btn:hover {
  box-shadow: 0 0 15px rgba(0, 229, 255, 0.4);
  background-color: rgba(0, 229, 255, 0.1);
}
</style>

<style>
/* Estilos globales para los menús desplegables (fuera de scoped) */
/* Ajustados para que combinen con la barra azul */

.tech-menu-content {
  /* Usamos un azul oscuro o negro translúcido para contraste, o podría ser el mismo uniColor si lo conocieramos */
  background-color: rgba(10, 20, 40, 0.95) !important; 
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 229, 255, 0.3);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.5);
  border-radius: 0 0 8px 8px !important;
}

.tech-list {
  background: transparent !important;
  padding: 0;
}

.tech-list-item {
  /* El texto blanco se fuerza en el template */
  transition: all 0.2s;
  cursor: pointer;
  border-left: 2px solid transparent;
}

.tech-list-item:hover {
  background-color: rgba(0, 229, 255, 0.15) !important;
  padding-left: 20px !important;
  border-left: 2px solid #00e5ff;
}

.tech-list-item:hover .v-list-item__icon .v-icon {
  color: #00e5ff !important;
  text-shadow: 0 0 5px #00e5ff;
}

/* Tooltip Tech */
.tech-tooltip {
  background-color: rgba(0, 0, 0, 0.9) !important;
  border: 1px solid #00e5ff;
  color: #ffffff !important; /* Texto blanco en tooltip */
  font-family: 'Fira Code', monospace;
  box-shadow: 0 0 10px rgba(0, 229, 255, 0.3);
}
</style>